import { Inject, Injectable } from '@angular/core';
import { MatStepperIntl } from '@angular/material/stepper';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

@Injectable()
export class StepperIntl extends MatStepperIntl {
  constructor(@Inject(I18NEXT_SERVICE) private i18nextService: ITranslationService) {
    super();
    i18nextService.events.languageChanged.subscribe((language) => {
      this.optionalLabel = i18nextService.getResource(language, 'common', 'buttons.stepper.optionalLabel');
      this.changes.next();
    });
  }
}
